import { Table, TableTdProps } from '@mantine/core';
import clsx from 'clsx';
import { forwardRef } from 'react';

export type RegistryTableTdProps = TableTdProps;

export const createRegistryTableTd = () => {
	const RegistryTableTd = forwardRef<HTMLTableCellElement, RegistryTableTdProps>(
		({ className, ...props }, ref) => (
			<Table.Td
				ref={ref}
				className={clsx('registry-table-td', className)}
				{...props}
			/>
		),
	);

	return RegistryTableTd;
};
